import loadable from '@loadable/component';


export default loadable(() => import(/* webpackChunkName: "international.firstvisit" */ './Loadable'));
